export default {
    name: "serverList",
    data: function() {
        return {
            cityId: this.$getCity(),
            catId: parseInt(this.$route.query.catId), //详情页返回时带的参数
            catList: [ //工作类型
                {
                    key: 1,
                    value: "1",
                    name: "临时保洁",
                    selected: false
                },
                {
                    key: 2,
                    value: "2",
                    name: "钟点工",
                    selected: false
                },
                {
                    key: 3,
                    value: "3,4",
                    name: "保姆",
                    selected: false
                },
                {
                    key: 6,
                    value: "6",
                    name: "育婴师",
                    selected: false
                },
                {
                    key: 5,
                    value: "5",
                    name: "月嫂",
                    selected: false
                },
                //{
                //    key: 99,
                //    value: "99",
                //    name: "其他",
                //    selected: false
                //},
            ],
            searchKey: this.$route.query.schKey ? this.$route.query.schKey : "", //详情页返回时带的参数
            page: 1,
            pageSize: 10,
            totalCount: 0,
            serverList: [], //阿姨列表
            isLoaded: false, //是否首页加载完

            pulluploadingtext: "正在努力加载更多…", //上拉加载中显示文案
            pulluptext: '', //上拉加载条文案
            allowpullup: true, //是否允许上拉加载
            pullend: false, //是否加载完
            isscroll: true, //是否可以滚动加载

            showButton: false, //是否显示【推荐】按钮
        }
    },
    watch: {
        '$route': function(to, from) {
            if (to && to.name === 'serverList') {
                this.init();
            }
        }
    },
    mounted: function() {
        this.init();
    },
    methods: {
        init() {
            if (this.$route.query.id) {
                this.showButton = true;
                this.mode = 'rcmd';
            } else {
                this.showButton = false;
                this.mode = 'show';
            }
            this.cityId = this.$getCity();
            this.catId = parseInt(this.$route.query.catId);
            this.searchKey = this.$route.query.schKey ? this.$route.query.schKey : "";
            this.isLoaded = false;
            this.page = 1;
            this.initCatList();
            this.getServerList();
            this.initTranslate();
            this.bindScrollEvents();
        },
        //初始化工作类型选中状态
        initCatList() {
            let self = this;
            let curCatId = self.catId && self.catId > 0 ? self.catId : 0;
            this.catList.map(item => {
                if (item.key == curCatId) {
                    item.selected = true;
                } else {
                    item.selected = false;
                }
            });
        },
        //切换工作类型
        switchCat(itemId) {
            let self = this;
            this.catList.map(item => {
                if (item.key == itemId) {
                    if (!item.selected) {
                        item.selected = true;
                        self.getServerList();
                    }
                } else {
                    item.selected = false;
                }
            });
        },
        //检测筛选条件
        resetParameter() {
            let self = this;
            let _param = {
                CityId: this.cityId,
                Page: this.page,
                Length: this.pageSize,
            };
            this.catList.map(item => {
                if (item.selected) {
                    _param.JobType = item.value;
                }
            });
            if (this.searchKey && this.searchKey != "") {
                _param.SearchCriteria = this.searchKey;
            }
            return _param;
        },
        //获取阿姨列表
        getServerList() {
            let self = this;
            self.isLoaded = false;
            this.page = 1;
            let _param = this.resetParameter();
            this.$post("/servant/getlistservant", _param, function(result) {
                self.isLoaded = true;
                if (result && result.TotalCount && result.TotalCount > 0) {
                    self.serverList = result.ListServant;
                    self.totalCount = result.TotalCount;
                } else {
                    self.serverList = [];
                    self.totalCount = 0;
                }
            })
        },
        viewDetail(itemId, jobType) {
            let _param = {
                jobType: jobType,
                platform: 2,
                fromPage: 2
            };
            this.catList.map(item => {
                if (item.selected) {
                    _param.catId = item.key;
                }
            });
            if (this.searchKey && this.searchKey != "") {
                _param.schKey = this.searchKey;
            }
            this.$router.push({
                path: "/serverDetail/" + itemId + "/" + (this.$route.query.id || 0),
                query: _param
            });
        },

        //内容拉到底部，上拉加载更多
        pullUpdate() {
            let self = this;
            let fullTotal = this.pageSize * this.page;
            if (this.totalCount && fullTotal <= this.totalCount) {
                this.setTranslate();
                if (this.page == 0) {
                    this.page = 1;
                } else {
                    this.page++;
                }
                let _param = this.resetParameter();
                this.$post("/servant/getlistservant", _param, function(result) {
                    if (result && result.ListServant && result.ListServant.length > 0) {
                        result.ListServant.map(item => {
                            self.serverList.push(item);
                        });
                    } else {
                        self.clearTranslate();
                    }
                })
            } else {
                this.clearTranslate();
            }
        },
        bindScrollEvents() {
            this.$el.querySelector(".server-list-panel").addEventListener('scroll', this.scrollEvents);
        },
        scrollEvents() {
            let self = this;
            if (this.allowpullup) {
                let target = this.$el.querySelector(".server-list-panel");
                // let scrollLimit = target.scrollHeight - target.offsetHeight;
                let pullUp = self.$el.querySelector(".pull-up");
                let pullUpTop = pullUp.offsetTop;
                // alert("加载前");
                if (pullUpTop <= target.offsetHeight + target.scrollTop + 250 && self.isscroll) {
                    // alert("准备加载");
                    self.pullUpdate();
                    // alert("加载中");
                    self.isscroll = false;
                    this.resetScroll = setTimeout(function() {
                        self.isscroll = true;
                        //clearTimeout(this.resetScroll);
                    }, 1500);
                }
            }
        },
        setTranslate(text) {
            if (!this.pullend) {
                this.pullend = false;
            }
            this.pulluptext = text ? text : this.pulluploadingtext;
            this.allowpullup = true;
        },
        clearTranslate() {
            this.pulluptext = '没有更多了哦~';
            this.allowpullup = true;
            this.pullend = true;
            this.isscroll = false;
        },
        initTranslate() {
            this.pulluploadingtext = "正在努力加载更多…";
            this.pulluptext = '';
            this.allowpullup = true;
            this.pullend = false;
            this.isscroll = true;
        },
        //search
        searchHandle(keyword) {
            let self = this;
            // if (!keyword || keyword == "") {
            //     self.alert = {
            //         cont: "请输入您要搜索的信息",
            //     };
            //     self.alert = self.$uAlert.show_alert(self.alert);
            //     return false;
            // }
            this.searchKey = keyword;
            //更新数据
            this.getServerList();
        },

        recommend(item) {
            if (!item.IsRecommend) {
                return;
            }

            this.$router.push({
                name: "salary",
                query: {
                    JobId: this.$route.query.id,
                    ServantAccountCode: item.AccountCode,
                    ProfileStoreId: item.ProfileStoreId,
                    ServantName: item.ServantName
                }
            });
            return false;
        },
        showServant: function(item) {
            this.$router.push({ name: "auntInfo", query: { id: item.ServantId, jobId: this.$route.query.id } });
        },
        addServant: function() {
            this.$router.push({
                name: "serverProfile",
                query: {
                    jobId: this.$route.query.id,
                    platform: 2,
                    fromPage: 2,
                }
            })
        }
    },
}



// WEBPACK FOOTER //
// ./src/ally/page/server/serverList.js